var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "combo-table" },
    _vm._l(_vm.list, function(item, key) {
      return _c("div", { key: key, staticClass: "combo-tr" }, [
        _c("div", { staticClass: "combo-td combo-tr-title" }, [
          _vm._v(_vm._s(item.title))
        ]),
        _c(
          "div",
          { staticClass: "combo-td" },
          [
            key === "groupB"
              ? _vm._l(item.cells, function(item, key) {
                  return _c(
                    "div",
                    {
                      key: key,
                      staticClass:
                        "am-g am-padding-vertical-xs combo-essential am-flex"
                    },
                    [
                      _c("div", { staticClass: "am-flex-num-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "am-button-custom active",
                            class: { disabled: item.disabled }
                          },
                          [
                            _c("div", { staticClass: "am-inline-block" }, [
                              _c("span", [_vm._v(_vm._s(item.name) + " ")]),
                              item.hasStock && !item.disabled
                                ? _c(
                                    "span",
                                    { staticClass: "am-padding-left-sm" },
                                    [
                                      _vm._v(
                                        "(库存：" + _vm._s(item.stockNum) + ")"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              item.warnText
                                ? _c(
                                    "span",
                                    { staticClass: "am-padding-left-sm" },
                                    [_vm._v(_vm._s(item.warnText))]
                                  )
                                : _vm._e()
                            ]),
                            item.property && item.num > 0
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "am-inline-block combo-additional-button",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.initComboAdditional(item)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v("特殊要求")]),
                                      item.num
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "prefix-price-unit"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.currency) +
                                                  _vm._s(
                                                    item.totalProductPrice
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]),
                      _c("div", { staticClass: "am-text-right" }, [
                        _c("div", { staticClass: "am-button-custom" }, [
                          _c("span", [_vm._v(_vm._s(item.num))]),
                          _vm._v("份\n            ")
                        ])
                      ])
                    ]
                  )
                })
              : _vm._e(),
            key === "groupC"
              ? _vm._l(item.items, function(item, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "am-margin-top-sm" },
                    [
                      _c("p", [_vm._v(_vm._s(item.title))]),
                      _c(
                        "RadioGroup",
                        {
                          on: { "on-change": _vm.updateCombo },
                          model: {
                            value: item.checkValue,
                            callback: function($$v) {
                              _vm.$set(item, "checkValue", $$v)
                            },
                            expression: "item.checkValue"
                          }
                        },
                        _vm._l(item.cells, function(item, key) {
                          return _c("Radio", {
                            key: key,
                            staticClass: "am-margin-top-10 am-margin-right-20",
                            attrs: {
                              label: key,
                              custom: "",
                              disabled: item.disabled
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var currentValue = ref.currentValue
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "am-button-custom",
                                        class: {
                                          active: currentValue,
                                          disabled: item.disabled
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "am-inline-block" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(item.name) +
                                                  " \n                    " +
                                                  _vm._s(
                                                    currentValue &&
                                                      item.num > 0 &&
                                                      item.price
                                                      ? "¥" +
                                                          item.price * item.num
                                                      : ""
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]),
                                            item.hasStock && !item.disabled
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "am-padding-left-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(库存：" +
                                                        _vm._s(item.stockNum) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            item.warnText
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "am-padding-left-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.warnText)
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        item.property &&
                                        currentValue &&
                                        item.num > 0
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "am-inline-block combo-additional-button",
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.initComboAdditional(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("特殊要求")
                                                  ]),
                                                  item.num
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "prefix-price-unit"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.currency
                                                              ) +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatPrice"
                                                                )(
                                                                  item.totalProductPrice -
                                                                    (item.price ||
                                                                      0) *
                                                                      (item.num ||
                                                                        0)
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                })
              : _vm._e(),
            key === "groupD"
              ? _vm._l(item.items, function(project, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticClass: "am-margin-bottom-sm" }, [
                        _c("span", [_vm._v(_vm._s(project.title))]),
                        project.maxNum > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "am-padding-left-sm am-color-price"
                              },
                              [_vm._v(_vm._s(project.warnText))]
                            )
                          : _vm._e()
                      ]),
                      _vm._l(project.cells, function(product, key) {
                        return _c(
                          "div",
                          {
                            key: key,
                            staticClass:
                              "am-flex am-flex-column-center am-padding-bottom-sm am-padding-horizontal-xs"
                          },
                          [
                            _c("div", { staticClass: "combo-label" }, [
                              _c("span", [_vm._v(_vm._s(product.name) + " ")]),
                              product.hasStock && !product.disabled
                                ? _c(
                                    "span",
                                    { staticClass: "am-padding-left-sm" },
                                    [
                                      _vm._v(
                                        "(库存：" +
                                          _vm._s(product.stockNum) +
                                          ")"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            product.disabled
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "am-button-custom disabled am-button-custom"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(product.warnText) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  product.property
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "am-button-custom am-margin-left-sm",
                                            class: {
                                              disabled: product.forbiddenAdd
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "am-inline-block"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(product.num) +
                                                    "份\n                    " +
                                                    _vm._s(
                                                      product.num *
                                                        (product.price || 0)
                                                        ? "¥" +
                                                            product.num *
                                                              (product.price ||
                                                                0)
                                                        : ""
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "am-inline-block combo-additional-button",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.initComboAdditional(
                                                      product
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("特殊要求")
                                                ]),
                                                product.num
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "prefix-price-unit"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.currency
                                                            ) +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatPrice"
                                                              )(
                                                                product.num &&
                                                                  product.price
                                                                  ? product.totalProductPrice -
                                                                      product.num *
                                                                        product.price
                                                                  : product.totalProductPrice
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        product.num
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "am-margin-left-sm am-button-custom",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.resetProductNum(
                                                      product
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  重置\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : [
                                        product.num && product.price
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "am-button-custom",
                                                staticStyle: {
                                                  "margin-right": "10px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "¥" +
                                                      product.num *
                                                        product.price
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("InputQuantity", {
                                          staticClass: "combo-input-quantity",
                                          attrs: {
                                            max: product.buyMaxNum,
                                            min: product.buyMinNum
                                          },
                                          on: { "on-change": _vm.updateCombo },
                                          model: {
                                            value: product.num,
                                            callback: function($$v) {
                                              _vm.$set(product, "num", $$v)
                                            },
                                            expression: "product.num"
                                          }
                                        })
                                      ]
                                ]
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                })
              : _vm._e()
          ],
          2
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96edb88a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96edb88a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/business/ComboGroup/ComboGroup.vue
// module id = 0hY5
// module chunks = 0